var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
  _vm.checkCategory() &&
  _vm.question.libraryQuestionId &&
  _vm.question.questionType == 'METADATA'
  )?_c('div',{staticClass:"customer-effort-question"},[(
      _vm.QUESTIONS_THRESHOLD_MAP[_vm.question.questionKey]
    )?_c('span',{staticClass:"customer-effort-option-label"},[_vm._v(_vm._s(_vm.QUESTIONS_THRESHOLD_MAP[_vm.question.questionKey]
        .label)+":\n  ")]):_vm._e(),_c('div',{staticClass:"threshold-section"},[_c('vue-numeric',{staticClass:"input-customer-effort-value",class:{
        'no-value':
          typeof _vm.question.thresholdValue !== 'number',
      },attrs:{"placeholder":_vm.QUESTIONS_THRESHOLD_MAP[_vm.question.questionKey]
          .placeholder,"minus":false,"precision":0},nativeOn:{"keypress":function($event){return _vm.callHandlePress($event)}},model:{value:(_vm.question.thresholdValue),callback:function ($$v) {_vm.$set(_vm.question, "thresholdValue", $$v)},expression:"question.thresholdValue"}}),_c('span',{staticClass:"customer-effort-threshold-title"},[_vm._v(_vm._s(_vm.QUESTIONS_THRESHOLD_MAP[_vm.question.questionKey]
        .title))]),_c('span',{staticClass:"customer-effort-threshold-des"},[_vm._v(_vm._s(_vm.QUESTIONS_THRESHOLD_MAP[_vm.question.questionKey]
        .desc))])],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }